var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dash-attempt" },
    [
      _c("div", { staticClass: "dash-attempt__badge" }, [
        _c(
          "div",
          { staticClass: "dash-attempt__badge-space" },
          [
            _c("jade-badge", { attrs: { variant: "text", voice: _vm.color } }, [
              _vm._v(" " + _vm._s(_vm.textBadge) + " "),
            ]),
          ],
          1
        ),
        _c("span", {
          staticClass: "dash-attempt__badge-line",
          class: { "dash-attempt__badge-line-first": _vm.firstItem },
          attrs: { "data-testid": "test-line" },
        }),
      ]),
      _c("jade-list-item", {
        attrs: {
          navigation: "",
          label: _vm.label,
          description: _vm.description,
          thirdLine: _vm.thirdLine,
          variant: _vm.computedVariant,
        },
        on: { onClick: _vm.clickAttempt },
        scopedSlots: _vm._u([
          {
            key: "trailing",
            fn: function () {
              return [
                _c(
                  "jade-text",
                  {
                    attrs: {
                      "data-testid": "test-trailing",
                      color: "medium",
                      variant: "text-medium",
                      weight: "medium",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.trailingText) + " ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }